module.exports = __webpack_public_path__ + "static/media/search.319a6540.svg";